import React, { useEffect, useState, useContext } from 'react';
import Modal from '../../components/modal/modal.component';
import Card from '../../components/card.component';
import { useForm } from "react-hook-form";
import connect from '../../views/axios/axios.auth';
import notification from '../notification.component';
import { ConfigContextUtils } from '../../context/contextUtils.context';


const CompleteMaster = ({ onConfirm = null, onCancel = null, buttonText, master_id, styleBtn, disabled }) => {

  const { setPreloader } = useContext(ConfigContextUtils);
  const { register, handleSubmit, errors, reset } = useForm();
  const [visible, setVisible] = useState(false);
  const [masterid, setMasterId] = useState(master_id);
  

  useEffect(() => {
    if (visible) {
        reset();
    }
    // eslint-disable-next-line
  },[visible])

  useEffect(() => {
    setMasterId(master_id);
  }, [master_id]);

  const onSubmit = (data) => {
    const payload = {
        ...data,
        master_id: masterid,
    }
    setPreloader(true);
    connect.post(`/master/full-delivery`, payload)
    .then((response) => {
        if (response.data.full_delivery) {
            notification.success();
            onConfirm(masterid);
            toggle();
        } else {
            notification.warning(response.data.message);
        }
        setPreloader(false);
    });
  }

  const toggle = () => {
      setVisible(!visible)
      if (onCancel !== null) {
        onCancel();
      }
  }


  return (
    <>
     <button 
        type="button"
        className={`btnx btnx-warn icon-table ${styleBtn}`}
        onClick={toggle}
        disabled={disabled}
      >
        {buttonText}
    </button>
    <Modal size="lg" show={visible}>
      <Card>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div style={{ marginTop: 10, marginBottom: 10 }}>
          <p style={{ fontWeight: 'bold' }}>¿Confirma que desea completar esta guia como entrega?</p>
        </div>
        <div className="mb-2">
            <div className="grupo-input">
                <small>Escriba la descripción del estado final, esto tomara en cuenta solo las guias que estan en transito.</small>
                <textarea type="text" className={`form-control input-border ${errors.descripcion_estado && "is-invalid mt-2"}`} name="descripcion_estado" ref={register({ required: true })} />
            </div>
        </div>
        <div className="mt-2">
          <button 
            onClick={toggle}
            type="button"
            className="btnx btnx-warn"
           >
             Cerrar
           </button>
           {' '}
           <button 
            type="submit"
            className="btnx btnx-warn"
           >
             Confirmar
           </button>
        </div>
        </form>
       </Card>
    </Modal>
    </>
  )
}

export default CompleteMaster;